import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Trash2, Plus } from "lucide-react";
import { toast } from "sonner";
import ImageUploader from "@/components/ImageUploader";
import { absUrl } from "@/lib/urls";

export default function AdminCategories() {
  const [list, setList] = useState([]);
  const [name, setName] = useState("");
  const [images, setImages] = useState([]);

  const load = () => api.get("/admin/categories").then(({ data }) => setList(data));
  useEffect(() => { load(); }, []);

  const save = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    await api.post("/admin/categories", { name: name.trim(), image: images[0] || null });
    toast.success("Categoria criada");
    setName(""); setImages([]); load();
  };
  const del = async (id) => { if (window.confirm("Remover categoria?")) { await api.delete(`/admin/categories/${id}`); load(); } };

  return (
    <div data-testid="admin-categories">
      <h1 className="font-display text-3xl text-[#49392F] mb-8">Categorias</h1>

      <form onSubmit={save} className="bg-white border border-[#C2A064]/20 p-5 space-y-4 mb-8">
        <input
          className="duo-input"
          placeholder="Nome da categoria *"
          value={name}
          onChange={(e) => setName(e.target.value)}
          data-testid="category-name-input"
        />
        <div>
          <div className="text-[11px] tracking-[0.3em] uppercase text-[#49392F]/80 mb-2">Imagem da categoria</div>
          <ImageUploader value={images} onChange={setImages} max={1} />
        </div>
        <button className="duo-btn duo-btn-primary" data-testid="category-save-button">
          <Plus size={14} /> Adicionar categoria
        </button>
      </form>

      <div className="bg-white border border-[#C2A064]/20">
        {list.length === 0 && <div className="p-6 text-center text-[#49392F]/60">Nenhuma categoria.</div>}
        {list.map((c) => (
          <div key={c.id} className="flex items-center justify-between p-4 border-b border-[#C2A064]/10 last:border-0">
            <div className="flex items-center gap-4">
              {c.image ? (
                <img src={absUrl(c.image)} alt={c.name} className="w-14 h-14 object-cover" />
              ) : (
                <div className="w-14 h-14 bg-[#F8F5EF] border border-[#E8DCCB]" />
              )}
              <div>
                <div className="text-[14px] text-[#49392F]">{c.name}</div>
                <div className="text-[11px] text-[#49392F]/60">{c.slug}</div>
              </div>
            </div>
            <button onClick={() => del(c.id)} className="p-2 text-[#49392F]/60 hover:text-[#49392F]" aria-label="remover" data-testid={`delete-cat-${c.id}`}>
              <Trash2 size={14} />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
